import Header from "../components/Header";
import Login from "../components/Login.js";
import Footer from "../components/Footer";

import "./styles.css"

export default function ContactUs() {
  return (
    <div className="Login">
      <Header></Header>
      <Login></Login>
      <Footer></Footer>
    </div>
  );
}
